import { render, staticRenderFns } from "./PaxAssignRoom.vue?vue&type=template&id=d08f7128&scoped=true&"
import script from "./PaxAssignRoom.vue?vue&type=script&lang=js&"
export * from "./PaxAssignRoom.vue?vue&type=script&lang=js&"
import style0 from "./PaxAssignRoom.vue?vue&type=style&index=0&id=d08f7128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08f7128",
  null
  
)

export default component.exports